import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("login_email", email); // username/email
      formData.append("login_password", password); // password

      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/login",
        formData
      );

      if (response.data.success === 1) {
        localStorage.setItem("loggedIn", "true");
        toast.success(response.data.message || "Login successful!");
        setTimeout(() => {
          window.location.hash = "/dashboard";
          window.location.reload();
        }, 100);
      } else {
        toast.error(response.data.message || "Invalid username or password.");
      }
    } catch (err) {
      toast.error("Error logging in. Please try again.");
    }
  };

  return (
    <div className="login-section">
      <form className="form" onSubmit={handleSubmit}>
        <span className="signup">Login</span>
        <input
          type="email"
          placeholder="Email address"
          className="form--input"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
        />
        <div className="password-wrapper">
          <input
            required
            placeholder="Password"
            className="form--input"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
          <button
            className="password-toggle"
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            <svg fill="none" viewBox="0 0 24 24" className="eye-icon">
              <path
                strokeWidth="1.5"
                stroke="currentColor"
                d="M2 12S5 5 12 5s10 7 10 7-3 7-10 7S2 12 2 12Z"
              />
              <circle
                strokeWidth="1.5"
                stroke="currentColor"
                r={3}
                cy={12}
                cx={12}
              />
            </svg>
          </button>
        </div>
        <button className="form--submit">Login</button>
      </form>
    </div>
  );
};

export default Login;